module.exports = __webpack_public_path__ + "3ced3466d293c26912b466368c68ba42.png";